import React from 'react';

const img = [
    { backgroundImage: `url('https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525364246/PVQW/weld1.jpg')` },
    { backgroundImage: `url('https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525364243/PVQW/weld2.jpg')` },
    { backgroundImage: `url('https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525364244/PVQW/weld4.jpg')` },
    { backgroundImage: `url('https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525364245/PVQW/weld5.jpg')` },
    { backgroundImage: `url('https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525364243/PVQW/weld6.jpg')` },
    { backgroundImage: `url('https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525364245/PVQW/weld7.jpg')` },
]

const Landing = () => (
    <ul className="background-img">
        <li><span style={img[0]}></span></li>
        <li><span style={img[1]}></span></li>
        <li><span style={img[2]}></span></li>
        <li><span style={img[3]}></span></li>
        <li><span style={img[4]}></span></li>
        <li><span style={img[5]}></span></li>
    </ul>
);

export default Landing;


// WEBPACK FOOTER //
// ./src/components/Slider.js